import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.goodsSystem
import qs from 'qs'

/**
 * 个人采购单（自采）模块——需求 FR-ZC-01~05 / 5.2 / 6.4
 * 销售（roleId 2、3）发起，仅可选已生效固定渠道，支持明细级商机选择
 * 注意：以下接口路径为前端预留，具体以后端为准（TODO 待后端联调确认）
 */

// 个人采购单列表（我的自采单）
export function getPersonalPurchaseList(data) {
    return request({
        url: serviceName + `/personal_purchase_list`,
        method: 'post',
        data: data
    })
}

// 新增个人采购单（含货物明细与明细级商机）
export function addPersonalPurchase(data) {
    return request({
        url: serviceName + `/add_personal_purchase`,
        method: 'post',
        data: data
    })
}

// 查询个人采购单明细
export function queryPersonalPurchase(data) {
    return request({
        url: serviceName + `/query_personal_purchase`,
        method: 'post',
        data: data
    })
}

// 删除个人采购单（草稿/驳回态可删）
export function deletePersonalPurchase(data) {
    return request({
        url: serviceName + `/delete_personal_purchase`,
        method: 'post',
        data: data
    })
}

// 个人采购单待审批/已审批记录（func=2 未审批 / func=1 已审批）
export function personalPurchaseApprovedList(data) {
    return request({
        url: serviceName + `/personal_purchase_approved_list` + '?' + qs.stringify(data),
        method: 'get',
        data: data
    })
}

// 查询已生效固定渠道（销售自采仅可选已生效固定渠道，FR-CH-03）
export function getActiveFixedChannelList(data) {
    return request({
        url: serviceName + `/active_fixed_channel_list`,
        method: 'post',
        data: data
    })
}
